/* @flow */
/* eslint-env es6,browser */

import adconfig from '../adconfig';
import adloader from '../adloader';
import _adserverbase from './adserverbase';
import { logError } from '../utils/logger';

/**
 * Implements static ad server functionality
 *
 * @class
 * @exports adserver/staticas
 * @requires  module:utils
 * @requires  module:adconfig
 * @requires  module:adloader
 * @requires  module:adserverbase
 * @requires module:logger
 */

class _staticAS extends _adserverbase {
  constructor(name: string) {
    super();
    this._name = name;
  }
  /**
   * Loads static using adloader
   *
   * @typedef {object} hbPosData
   * @param {Array<string>} posList - position list array
   * @param {object.<string, hbPosData>} o - header bidding return object
   * @param {object} customVars - custom variable to be populated inside iframe
   * @param {boolean} bRotation - For ad rotation?
   * @returns {undefined}
   */
  loadAds(
    posList: Array<string>,
    o: hbPartnerData,
    customVars: Object,
    bRotation: boolean
  ) {
    posList = posList || [];
    posList.forEach(pos => {
      const content = adconfig.getCreative(pos);
      if (!content.length) {
        logError(`${this._name} creative is missing for ${pos}`);
        return;
      }
      const cVars = this._getCustomVars(pos, o, customVars, bRotation);
      adloader.load(pos, content, cVars);
    });
  }
}
const staticAS = new _staticAS('staticAS');
export { staticAS };
